import { PublicKey } from '@solana/web3.js';
import { getBytesCodec, getStructCodec, getU32Codec } from '@solana/codecs';
var tokenGroupCodec = getStructCodec([['updateAuthority', getBytesCodec({
  size: 32
})], ['mint', getBytesCodec({
  size: 32
})], ['size', getU32Codec()], ['maxSize', getU32Codec()]]);
export var TOKEN_GROUP_SIZE = tokenGroupCodec.fixedSize; // Checks if all elements in the array are 0

function isNonePubkey(buffer) {
  for (var i = 0; i < buffer.length; i++) {
    if (buffer[i] !== 0) {
      return false;
    }
  }

  return true;
} // Pack TokenGroup into byte slab


export function packTokenGroup(group) {
  var _group$updateAuthorit;

  // If no updateAuthority given, set it to the None/Zero PublicKey for encoding
  var updateAuthority = (_group$updateAuthorit = group.updateAuthority) !== null && _group$updateAuthorit !== void 0 ? _group$updateAuthorit : PublicKey.default;
  return tokenGroupCodec.encode({
    updateAuthority: updateAuthority.toBuffer(),
    mint: group.mint.toBuffer(),
    size: group.size,
    maxSize: group.maxSize
  });
} // unpack byte slab into TokenGroup

export function unpackTokenGroup(buffer) {
  var data = tokenGroupCodec.decode(buffer);
  return isNonePubkey(data.updateAuthority) ? {
    mint: new PublicKey(data.mint),
    size: data.size,
    maxSize: data.maxSize
  } : {
    updateAuthority: new PublicKey(data.updateAuthority),
    mint: new PublicKey(data.mint),
    size: data.size,
    maxSize: data.maxSize
  };
}